import sprayApplicationRecord from "./sprayApplicationRecord";
import sprayStartSpray from "./sprayStartSpray";
import spraySuccess from "./spraySuccess";
import sprayPublicApplicationRecord from "./sprayPublicApplicationRecord";
import sprayPublicLog from "./sprayPublicLog";
import sprayHomescreenSection from "./sprayHomescreenSection";

export default [
    sprayHomescreenSection,
    sprayApplicationRecord,
    sprayStartSpray,
    spraySuccess,
    sprayPublicLog,
    sprayPublicApplicationRecord,
];
